module.exports = __webpack_public_path__ + "static/media/layout__.50e29603.svg";